import React from 'react';
import { Avatar } from '@mui/material';
import { Persona } from '../../lib/api/Persona';
import { TypingDots } from './TypingDots';

interface TypingIndicatorProps {
    persona?: Persona | null;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ persona }) => (
    <div className="message-wrapper assistant">
        <div className="message-avatar">
            <Avatar
                src={persona?.imageURL || persona?.avatar_url}
                alt={persona?.name}
                sx={{
                    width: 32,
                    height: 32,
                    bgcolor: 'var(--color-accent)',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    border: '1.5px solid var(--color-accent-soft)',
                    color: 'white'
                }}
            >
                {persona?.name?.charAt(0).toUpperCase() || 'A'}
            </Avatar>
        </div>
        <div className="message-bubble typing-indicator">
            <TypingDots />
        </div>
    </div>
);
